import { MIMEType } from 'node:util';

export const WILDCARD_TYPE = '*';
export const ALL = new MIMEType(`${WILDCARD_TYPE}/${WILDCARD_TYPE}`);
export const APPLICATION_OCTET_STREAM_VALUE = 'application/octet-stream';
export const APPLICATION_OCTET_STREAM = new MIMEType(APPLICATION_OCTET_STREAM_VALUE);

export function isWildcardType(mimeType: MIMEType): boolean {
    return mimeType.type === WILDCARD_TYPE;
}

export function isWildcardSubtype(mimeType: MIMEType): boolean {
    return mimeType.subtype === WILDCARD_TYPE || mimeType.subtype.startsWith(`${WILDCARD_TYPE}+`);
}

export function isConcrete(mimeType: MIMEType): boolean {
    return !isWildcardType(mimeType) && !isWildcardSubtype(mimeType);
}


export class InvalidMimeTypeError extends Error {
    readonly mimeType: string;
    constructor(mimeType: string, message?: string, options?: ErrorOptions) {
        super(message === undefined ? `Invalid MIME type "${mimeType}"` : `Invalid MIME type "${mimeType}": ${message}`, options);
        this.mimeType = mimeType;
    }
}

export function createMimeType(type: string, subtype: string, charset?: string): MIMEType {
    const input = `${type}/${subtype}`;
    let result: MIMEType;
    try {
        result = new MIMEType(input);
    }
    catch (error) {
        throw new InvalidMimeTypeError(input, undefined,  { cause: error } );
    }
    if (charset) {
        result.params.set('charset', charset);
    }
    return result;
}

export function getSubtypeSuffix(mimeType: MIMEType): string | null {
    const suffixIndex = mimeType.subtype.lastIndexOf('+');
    if (suffixIndex !== -1 && suffixIndex < mimeType.subtype.length) {
        return mimeType.subtype.substring(suffixIndex + 1);
    }
    return null;

}

export function isCompatibleWith(a: MIMEType, b?: MIMEType): boolean {
    if (!b) {
        return false;
    }

    if (isWildcardType(a) || isWildcardType(b)) {
        return true;
    }

    else if (a.type === b.type) {
        if (a.subtype === b.subtype) {
            return true;
        }
        if (isWildcardSubtype(a) || isWildcardSubtype(b)) {
            const aSuffix = getSubtypeSuffix(a);
            const bSuffix = getSubtypeSuffix(b);
            if (a.subtype === WILDCARD_TYPE || b.subtype === WILDCARD_TYPE) {
                return true;
            }
            else if (isWildcardSubtype(a) && bSuffix !== null) {
                return aSuffix === b.subtype || aSuffix === bSuffix;
            }
            else if (isWildcardSubtype(b) && aSuffix !== null) {
                return a.subtype === bSuffix || bSuffix === aSuffix;
            }
        }
    }
    return false;
}
